import videoPlayer from '../../../../shared/videoPlayer'

export default () => {
  videoPlayer();
};
